<section class="container-fluid summary-panel">
    <app-data-table #dataTable [columns]="columns" [sortColumn]="sortColumn" [loadPage]="loadPage" [(filters)]="filters" [pageSize]="10"
                    [allowItemSelection]="true" [filtersComponent]="dataFilters" [direction]="direction"
                    (onItemSelection)="selectLocation($event)" (onLoad)="pageLoaded($event)">
        <app-data-filters #dataFilters [opened]="true" [fullWidth]="true" [hidden]="!authService.canManageLocations() && !authService.canReadLocations()">
            <app-data-filter-group [useAvailableWidth]="true">

                <app-data-filter-input [labelKey]="'local-loads.locations.list.filters.name.label'" [(model)]="filters.name"
                                       [placeholderKey]="'local-loads.locations.list.filters.name.placeholder'"></app-data-filter-input>

                <app-data-filter-input [labelKey]="'local-loads.locations.list.filters.glid.label'" [(model)]="filters.glid"
                                       [placeholderKey]="'local-loads.locations.list.filters.glid.placeholder'"></app-data-filter-input>

                <app-data-filter-input [labelKey]="'local-loads.locations.list.filters.zip-code.label'" [(model)]="filters.zipCode"
                                       [placeholderKey]="'local-loads.locations.list.filters.zip-code.placeholder'"></app-data-filter-input>

                <app-data-filter-input [labelKey]="'local-loads.locations.list.filters.city.label'" [(model)]="filters.city"
                                       [placeholderKey]="'local-loads.locations.list.filters.city.placeholder'"></app-data-filter-input>

                <app-data-filter-input [labelKey]="'local-loads.locations.list.filters.country.label'" [(model)]="filters.country"
                                       [placeholderKey]="'local-loads.locations.list.filters.country.placeholder'"></app-data-filter-input>

                <app-data-filter-select [labelKey]="'local-loads.locations.list.filters.region.label'" [(model)]="filters.region" [options]="regionOptions"
                                        [emptyOption]="true" [emptyOptionKey]="'local-loads.locations.list.filters.region.placeholder'"></app-data-filter-select>

                <app-data-filter-select [labelKey]="'local-loads.locations.list.filters.type.label'" [(model)]="filters.type"
                                        [options]="typeOptions"></app-data-filter-select>

                <app-data-filter-select [labelKey]="'local-loads.locations.list.filters.yms-compatible.label'" [(model)]="filters.ymsCompatible"
                                        [options]="ymsCompatibleOptions"></app-data-filter-select>

                <app-data-filter-select [labelKey]="'local-loads.locations.list.filters.colt.label'" [(model)]="filters.colt"
                                        [options]="booleanOptions"></app-data-filter-select>

                <app-data-filter-select [labelKey]="'local-loads.locations.list.filters.coords-approved.label'" [(model)]="filters.coordinatesValidated"
                                        [options]="booleanOptions"></app-data-filter-select>
            </app-data-filter-group>
        </app-data-filters>
    </app-data-table>
</section>


<ng-template #nameColumn let-name="name">
    {{ name }}
</ng-template>

<ng-template #glidColumn let-glid="glid">
    {{ glid }}
</ng-template>

<ng-template #address1Column let-address="address">
    {{ address.address1 }}
</ng-template>

<ng-template #address2Column let-address="address">
    {{ address.address2 }}
</ng-template>

<ng-template #zipCodeColumn let-address="address">
    {{ address.zip }}
</ng-template>

<ng-template #cityColumn let-address="address">
    {{ address.city }}
</ng-template>

<ng-template #countryColumn let-address="address">
    {{ address.country }}
</ng-template>

<ng-template #regionColumn let-configuration="configuration">
    <a class="cmaweb-link" *ngIf="canManageRegions" [href]="link.goToRegion(configuration.region.name)" target="_blank">{{ configuration.region.name }}</a>
    <span *ngIf="!canManageRegions">{{configuration.region.name}}</span>
</ng-template>

<ng-template #typeColumn let-type="type">
    <span [i18n]="'local-loads.locations.types.' + type.toLowerCase()"></span>
</ng-template>

<ng-template #ymsCompatibleColumn let-configuration="configuration" let-name="name">
    <span [i18n]="'feature-compatibility.' + configuration.ymsCompatible.value"></span>
</ng-template>

<ng-template #coltColumn let-configuration="configuration">
    <span [i18n]="'feature-compatibility.' + (configuration.colt ? 'YES' : 'NO')"></span>
</ng-template>

<ng-template #coordsApprovedColumn let-coordinatesValidated="coordinatesValidated">
    <span *ngIf="coordinatesValidated"><i class="fa fa-check-circle text-success"></i></span>
    <span *ngIf="!coordinatesValidated"><i class="fa fa-times-circle text-warning"></i></span>
</ng-template>

<ng-template #coordsColumn let-latitude="latitude" let-longitude="longitude">
    <span>{{latitude + ' / ' + longitude}}</span>
</ng-template>
